import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, Subject } from "rxjs";
import { IdentityModel } from "../models/identity.model";
import { map } from "rxjs/operators";
import * as _moment from "moment";
import { environment } from "src/environments/environment";
import { CiCdConfigService } from "src/cicd/ci-cd-config.service";

@Injectable({
  providedIn: "root"
})
export class BackEndService {
  protected ngUnsubscribe: Subject<void> = new Subject<void>();
  private urlApi: string;
  public Headers: any;
  public identity = new IdentityModel();
  public token: any;
  public userData = new IdentityModel();
  public headers: any;

  constructor(public http: HttpClient,
    private readonly ciCd: CiCdConfigService
  ) {
    // this.urlApi = environment.urlApi; // PREJENKINS
    this.ciCdInit();
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));

    this.headers = new HttpHeaders();
    this.headers = this.headers.set(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );
    this.headers = this.headers.set("token", localStorage.getItem("tokenCVE"));
  }

  ciCdInit() {
    this.ciCd.loadConfigurations().subscribe(({ apis }: any) => {
      const { urlApi } = apis;
      this.urlApi = urlApi;
    });
  }

  getquery(query: string, affiliate: any) {
    let headers = new HttpHeaders();
    headers = headers.set("Content-Type", "application/x-www-form-urlencoded");
    headers = headers.set("token", localStorage.getItem("tokenCVE"));
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));

    const options = { params: affiliate, headers };
    return this.http.get(`${this.urlApi}/${query}`, options);
  }

  getDebtsReport(affiliate: object) {
    return this.getquery("pr_reporte_cartera_afiliado", affiliate);
  }

  getDeptorsReport(affiliate: object) {
    return this.getquery("pr_reporte_deudores_afiliado", affiliate);
  }

  GetOrdenPago(datos: any) {
    this.Headers = new HttpHeaders({
      "Content-Type": "application/json",
    });

    const options = { headers: this.Headers, params: datos };
    const urlApi = environment.urlApiPayzen;
    return this.http.get(
      `${urlApi}/retornar_referencia_pago_en_linea`,
      options
    );
  }

  GetPayzen(datos: any) {
    this.Headers = new HttpHeaders({
      "Content-Type": "application/json",
    });

    const options = { headers: this.Headers, params: datos };
    const urlApi = environment.urlApiPayzen;
    return this.http
      .get(`${urlApi}/retornar_datos_pago_payzen_prod`, options)
      .pipe(
        map((resp: any) => {
          const payzenValues = Object.keys(resp).map((payzenKey) => {
            return {
              key: payzenKey,
              value: resp[payzenKey],
            };
          });
          return payzenValues;
        })
      );
  }

  GenerarPago(body?: any, email?: string) {
    this.Headers = new HttpHeaders({
      "Content-type": "application/x-www-form-urlencoded",
    });

    body.url_retorno = "https://www.covinoc.com";
    body.email = email;

    const options = { headers: this.Headers, params: body };
    const urlApi = environment.urlApiPayzen;
    return this.http.post(
      `${urlApi}/generar_pago`,
      body,
      options
    );
  }

  changePass(newPass: any) {
    return this.getquery("pr_buscar", newPass);
  }
}
